import Swiper from './swiper-setup';
import mq from 'js-mq';
import $ from 'jquery';


export default (selector, options) => {

  $(_ => {

    const el = document.querySelector(selector);

    if (!el) return;

    options = Object.assign({
      prevButton: '.ss__btn-page--prev',
      nextButton: '.ss__btn-page--next',
      wrapperClass: 'ss__slides',
      slideClass: 'js-ss-slide',
      slidesPerView: 3,
      slidesPerGroup: 3,
      spaceBetween: 20,
      breakpoints: {
        767: {
          slidesPerView: 1,
          slidesPerGroup: 1
        }
      }
    }, options);

    const swiper = new Swiper(el, options);
    const $slides = $(swiper.slides).not('.swiper-slide-duplicate');

    if (!options.loop) {
      const numSlides = $slides.length;
      const $btnsPrevNext = $([swiper.prevButton[0], swiper.nextButton[0]]).hide();
      let prevNextVisible = false;

      mq.on('*', _ => {

        if (numSlides <= swiper.params.slidesPerView) {
          if (prevNextVisible) {
            $btnsPrevNext.hide();
            prevNextVisible = false;
          }
        } else {
          if (!prevNextVisible) {
            $btnsPrevNext.show();
            prevNextVisible = true;
          }
        }
      }, true);
    }

  });
}